import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { ssoErrorKey } from '@/features/auth/lib/ssoErrors'

/**
 * The `?ssoError=<key>` a failed SSO round trip returns with, shared by `/login`
 * and `/accept-invite` (fix cycle 1b, review low A3 — the strip effect used to
 * be pasted into both pages).
 *
 * Returns the key read on the FIRST render, already mapped through the
 * allowlist (an unknown key becomes the generic one, never the raw text), and
 * then strips the param from the URL — keeping every other param, such as the
 * invite `token` — so a reload does not show a stale message again.
 */
export function useSsoErrorParam(): string | null {
  const [searchParams, setSearchParams] = useSearchParams()
  const [initial] = useState<string | null>(() => {
    const raw = searchParams.get('ssoError')
    return raw === null ? null : ssoErrorKey(raw)
  })

  useEffect(() => {
    if (!searchParams.has('ssoError')) return
    const next = new URLSearchParams(searchParams)
    next.delete('ssoError')
    setSearchParams(next, { replace: true })
  }, [searchParams, setSearchParams])

  return initial
}
